import { render, staticRenderFns } from "./SignIn.vue?vue&type=template&id=10c35b58&"
import script from "./SignIn.vue?vue&type=script&lang=ts&"
export * from "./SignIn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports